<p>
  child-window works! <br />
  {{ hash?.value }}
</p>
